import { RECALL1, RECALL2 } from "../type"

export const setRecall1 = (data) => ({ type: RECALL1, payload: data })
export const setRecall2 = () => ({ type: RECALL2 })